import logo from '../../assets/brand/caterinx-logo.png';
import { cn } from '../../lib/utils';

/**
 * Die Wortmarke „CATERINX.com" für Portal und Admin-App.
 *
 * **Dieselbe Datei wie auf der Marketing-Seite** — sie liegt in `src/assets/brand/` dieses Pakets,
 * und `apps/marketing/src/components/Logo.astro` importiert sie von hier. Ein Kunde, der auf
 * caterinx.com eine Anfrage abschickt und den Link zu seiner Statusseite öffnet, sieht oben
 * dasselbe Zeichen; bis D30 stand dort „CATERINX" als Text in der Systemschrift.
 *
 * Ein `<img>` statt eines SVG-Nachbaus: Die Vorlage ist ein freigestelltes PNG, und ein
 * nachgezeichneter Schriftzug weicht in genau den Details ab, an denen man eine Marke erkennt.
 * Die Datei ist 546 px breit; bei den üblichen 140–180 px Anzeigebreite reicht das auch für
 * dreifache Pixeldichte.
 *
 * `alt="caterinx"` — steht die Marke in einer Überschrift neben weiterem Text („Lieferantenportal"),
 * liest ein Screenreader beides zusammen.
 */
export function Wordmark({ className }: { className?: string }): React.JSX.Element {
  return (
    <img
      src={logo}
      alt="caterinx"
      width={546}
      height={65}
      decoding="async"
      className={cn('h-auto w-40 shrink-0', className)}
    />
  );
}
